<template>
  <page-content-placeholder
    icon="check"
    icon-color="success"
    prompt-text="Complete"
  >
    <template #message>All conflicts have been resolved.</template>
  </page-content-placeholder>
</template>

<script>
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder';

export default {
  name: 'ScreenTabConflictingEmptyState',
  components: {
    PageContentPlaceholder,
  },
};
</script>
